import styled from 'styled-components';

import backgroundImage from '../../../assets/images/login-background.png';

export const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  
  min-height: 100vh;

  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  overflow: auto;
`;
